import { LegendContinuous } from './legendContinuous';
export const LegendContinuousBlockSize = (options) => {
    return LegendContinuous(Object.assign({}, { type: 'size', block: true, labelShowTick: false }, options));
};
LegendContinuousBlockSize.props = Object.assign(Object.assign({}, LegendContinuous.props), { defaultPosition: 'top', defaultOrientation: 'horizontal' });
//# sourceMappingURL=legendContinuousBlockSize.js.map